export enum RevenueSource {
  TRIVECGROUP = "trivecgroup",
  TEBI = "tebi",
  GASTRODESK = "gastrodesk",
  BOOQ = "booq",
  UNTIL = "until",
  CASHDESK = "cashdesk",
  SCANFIE = "scanfie",
  LIGHTSPEED = "lightspeed",
  ARCDRINKS = "arcdrinks",
}

export const getRevenueSourceDisplayName = (source: RevenueSource): string => {
  switch (source) {
    case RevenueSource.TRIVECGROUP:
      return "BORK / Trivec";
    case RevenueSource.TEBI:
      return "Tebi";
    case RevenueSource.GASTRODESK:
      return "Gastrodesk";
    case RevenueSource.BOOQ:
      return "DISH (formerly booq)";
    case RevenueSource.UNTIL:
      return "unTill";
    case RevenueSource.CASHDESK:
      return "CashDesk";
    case RevenueSource.SCANFIE:
      return "Scanfie";
    case RevenueSource.LIGHTSPEED:
      return "LightSpeed";
    case RevenueSource.ARCDRINKS:
      return "aRC Drinks";
    default:
      return source;
  }
};

export const getAvailableRevenueSources = (): RevenueSource[] => {
  return Object.values(RevenueSource);
};
/** Onboarding-only brands deliberately do not extend the integration enum. */
export const getSetupPosDisplayName = (source: string, dishName?: string): string => (source === RevenueSource.BOOQ && dishName ? dishName : ({
  mpluskassa: 'MplusKASSA', twelve: 'Twelve',
  oracle_micros_simphony: 'Oracle MICROS Simphony', vectron: 'Vectron',
}[source] || getRevenueSourceDisplayName(source as RevenueSource)));
